import { StreemApiCreateSignedDownloadUrlRequestScope, StreemAPI } from '@streem/api';
import { logger } from './logger';
export async function fetchDownloadUrl(roomId, storageUrl, maxRetries = 3) {
    for (let i = 0; i < maxRetries; i++) {
        try {
            const { downloadUrl } = await StreemAPI.downloads.createSignedDownloadUrl({
                storageUrl,
                scope: StreemApiCreateSignedDownloadUrlRequestScope.ROOM,
                scopeSid: roomId.toString(),
            });
            if (downloadUrl)
                return downloadUrl;
        }
        catch (e) {
            // Thrown error usually suggests retries won't be successful
            logger.error('Failed to create signed downloadUrl for storageUrl', storageUrl, e);
            return undefined;
        }
        // Sometimes, storage URL is available before item actually exists. Wait 5s between tries for upload to complete.
        await new Promise(res => setTimeout(res, 5000));
    }
    logger.error('Failed to create signed downloadUrl for storageUrl', storageUrl, 'Ran out of retries');
}
//# sourceMappingURL=fetch_download_url.js.map